import { createRouter, createWebHistory } from 'vue-router';
import UserLogin from '@/views/UserLogin.vue';
import ExternalAuth from '@/views/ExternalAuth.vue';
import ChamadoAuth from '@/views/ChamadoAuth.vue';
import DashboardInicio from '@/views/Dashboard.vue';
import DetalhesChamado from '@/views/Detalhes/Inicio.vue';
import EmpresasIndex from '@/views/Empresas/Index.vue';

const routes = [
  

  {
    path: '/',
    name: 'Dashboard',
    component: DashboardInicio
  },
  {
    path: '/detalhes/:id',
    name: 'Detalhes do chamado',
    component: DetalhesChamado
  },
  
  
  // {
  //   path: '/FinalizarCadastroPF',
  //   name: 'FinalizarCadastroPF',
  //   component: CadastroPF_Passo_1
  // },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/auth/external',
    name: 'ExternalAuth',
    component: ExternalAuth
  },
  {
    path: '/chamado',
    name: 'ChamadoAuth',
    component: ChamadoAuth
  },
  {
    path: '/empresas',
    name: 'Empresas',
    component: EmpresasIndex
  },
  // ...outras rotas
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/auth/external', '/chamado', '/CadastroInicio', '/CadastroFinalizacao', '/RecuperarSenha'];

  const isPublicRoute = publicPages.includes(to.path);

  // Se é uma rota pública (estática ou dinâmica), não precisa de autenticação
  const authRequired = !isPublicRoute;

  const token = localStorage.getItem('token');

  if (authRequired && token == null) {
    next('/login');
  } else {
    next();
  }
});

export default router;
